import { Visibility } from "@material-ui/icons";
import React from "react";
import './widgetSm.css'
const WidgetSm = () => {
  return (
    <div className="widget_sm">
      <span className="widget_sm_title"> New Join Menbers</span>
      <ul className="widget_sm_list">
        <li className="widget_sm_list_item">
          <img
            src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
            alt=""
            className="widget_sm_img"
          />
          <div className="widget_sm_user">
            <span className="widget_sm_userName">Jaran Donchaaim</span>
            <spam className="widget_sm_useTitle">Web developer</spam>
          </div>
          <button className="widget_sm_button">
            <Visibility className="widget_sm_icon" />
            Display
          </button>
        </li>
        <li className="widget_sm_list_item">
          <img
            src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
            alt=""
            className="widget_sm_img"
          />
          <div className="widget_sm_user">
            <span className="widget_sm_userName">Jaran Donchaaim</span>
            <spam className="widget_sm_useTitle">Web developer</spam>
          </div>
          <button className="widget_sm_button">
            <Visibility className="widget_sm_icon" />
            Display
          </button>
        </li>
        <li className="widget_sm_list_item">
          <img
            src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
            alt=""
            className="widget_sm_img"
          />
          <div className="widget_sm_user">
            <span className="widget_sm_userName">Jaran Donchaaim</span>
            <spam className="widget_sm_useTitle">Web developer</spam>
          </div>
          <button className="widget_sm_button">
            <Visibility className="widget_sm_icon" />
            Display
          </button>
        </li>
      </ul>
    </div>
  );
};

export default WidgetSm;
